import { render } from "./PropertyDashboard.vue?vue&type=template&id=2e264b48&scoped=true&ts=true"
import script from "./PropertyDashboard.vue?vue&type=script&lang=ts"
export * from "./PropertyDashboard.vue?vue&type=script&lang=ts"

import "./PropertyDashboard.vue?vue&type=style&index=0&id=2e264b48&scoped=true&lang=scss"
import "./PropertyDashboard.vue?vue&type=style&index=1&id=2e264b48&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e264b48"]])

export default __exports__